import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationError } from '@angular/router';

import { AuthService } from './auth/auth.service';
import { CommonService } from './common/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { Title, Meta } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  UniqueId : any;

  constructor(private _router: Router, private translate: TranslateService,
    private _authService: AuthService, private _commonService: CommonService,private gtmService: GoogleTagManagerService) {
    this.onRouteChange();
    translate.setDefaultLang(_commonService.defaultLang);
  }

  ngOnInit() {
    
    if(localStorage.getItem("UniqueId") != null)
    {
      this.UniqueId = localStorage.getItem("UniqueId");
    }
    localStorage.clear();
    sessionStorage.clear();

    if(this.UniqueId != null)
    {
      localStorage.setItem("UniqueId",this.UniqueId);
    }


    localStorage.removeItem('authToken');
    if (!this._authService.getToken()) {
      this._authService.getAuthToken();
    }
  
    this._router.events.forEach(item => {
      if (item instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page',
          pageName: item.url
        };
        this.gtmService.pushTag(gtmTag);

        // this.pixel.track('Search',{
        //     content_name :'page',
        //     search_string:item.url
        // });
      }
    });


  }

  /** Method to load script files on routing to a new component
   * It also brings page view to top while navigating from the middle/bottom of other components
   */
  onRouteChange() {
    this._router.events.subscribe((evt) => {
    if (evt instanceof NavigationEnd) {
        this._commonService.loadScript();
        return;
    }
    if (evt instanceof NavigationError) {
      this._router.navigate(['/vliegtickets']);
      return;
  }

 
    window.scrollTo(0, 0);
    });
  }
}
